import { useFirestoreQuery } from '../../firebase/useFirestore'

/**
 * Alle projectafspraken van de huidige omgeving (`Type: 'projectFollowUp'`).
 *
 * Eén definitie van de zoekopdracht; wie er per project mee wil rekenen doet
 * dat op het resultaat. Let op: dit deelt géén luisteraar tussen kaarten —
 * elke aanroep zet er zelf een op. Dat is hier verantwoord omdat de twee
 * kaarten alleen samen op het dashboard van de beheeromgeving staan, waar het
 * om een handvol documenten gaat. Komt er een derde afnemer of een omgeving
 * met veel afspraken bij, til dit dan naar een provider zoals de
 * portfolio-huisbezoekkaarten dat doen (patterns.md#dashboard-portfolio-aggregation-card).
 *
 * Alleen een portfolio- of beheeromgeving legt afspraken vast; elders komt de
 * vraag altijd leeg terug, dus daar loopt hij niet.
 *
 * AI-CONTEXT: See docs/features/deccos-projectafspraken.md
 *
 * @param {boolean} enabled - Of de zoekopdracht mag draaien
 * @returns {Array<object>|string} De afspraken, of '' zolang er nog niets binnen is
 */
const useProjectFollowUpTasks = (enabled) =>
    useFirestoreQuery('Tasks', {
        where: [['Type', '==', 'projectFollowUp']],
        enabled,
    })

export default useProjectFollowUpTasks
